<template>
    <div>
        <el-dialog title="添加产品"  v-model="dialogFormVisible" width="90%" top="5%">
            <el-form ref="formProduct" :model="formProduct" :rules="formProductRules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="大类名" prop="ProductDetail_mtype" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.ProductDetail_mtype" @change="handleSubType" placeholder="请选择">
                                <el-option
                                v-for="item in mType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="小类名" prop="ProductDetail_stype" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.ProductDetail_stype" placeholder="请选择">
                                <el-option
                                v-for="item in sType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="产品名称" prop="ProductDetail_name" :label-width="formLabelWidth">
                            <el-input v-model="formProduct.ProductDetail_name"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="产品状态" prop="ProductDetail_status" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.ProductDetail_status" placeholder="请选择">
                                <el-option
                                v-for="item in status"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-tooltip class="item" effect="dark" content="0:默认不展示在首页，1-6：为展示在首页产品（如果同样的数字，最靠近1为优先）" placement="top-start">
                                <pfInfoFilled style="float: inline-end;width: 1em; height: 1em; margin: 8px 0 0 8px; "></pfInfoFilled>
                        </el-tooltip>
                        <el-form-item label="展示位置" prop="isShow" :label-width="formLabelWidth">
                            <el-input v-model="formProduct.isShow"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="产品语言" prop="lang" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.lang" placeholder="请选择">
                                <el-option
                                v-for="item in lang"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="产品图片" prop="attchs" :label-width="formLabelWidth">
                            <span v-for="( item, index ) in formProduct.attchs" :key="item"  class="removeImage" :style="spanleft(index)">
                                <pfDelete v-if="item" @click="handleRemoveImage(item)" style="width: 1em; height: 1em; margin-right: 8px" />
                            </span>
                            <el-upload
                                class="avatar-uploader" 
                                :show-file-list="false"
                                :on-progress="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                >
                                <span v-for="( item ) in formProduct.attchs" :key="item">
                                    <el-image v-if="item" style="width: 100px; height: 100px" :src="item" class="avatar" />
                                </span>
                                <el-icon v-if="formProduct.attchs.length < 3" class="avatar-uploader-icon"><pfPlus /></el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <div>（如果上传图片出错[网络原因]请重新刷新，再次录入。）</div>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="备注" prop="ProductDetail_Remark" :label-width="formLabelWidth">
                            <el-input v-model="formProduct.ProductDetail_Remark"  type="textarea" :rows="2"></el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-tabs
                    v-model="formProduct.typeNumberName"
                    type="border-card"
                    class="demo-tabs1"
                    v-show="false"
                >
                    <el-tab-pane label="属性一" :name=1>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="官能度" prop="ProductDetail_functionality" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_functionality"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="APHA No. (max.)" prop="ProductDetail_APHANO" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_APHANO"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="羟值 (mgKOH/g)" prop="ProductDetail_hydroxyl_value" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_hydroxyl_value"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="分子量 (Avg.)" prop="ProductDetail_MW" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_MW"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="水份 (%, max.)" prop="ProductDetail_watercontent" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_watercontent"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="粘度 (cps,25℃)" prop="ProductDetail_vicosity" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_vicosity"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="钾&钠离子 (ppm,max.)" prop="ProductDetail_NaK" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_NaK"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="固含量 (%, avg.)" prop="ProductDetail_Solid" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_Solid"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="应用" prop="ProductDetail_Application" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_Application"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="CP" prop="ProductDetail_CP" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_CP"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="EO" prop="ProductDetail_EO" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_EO"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性二" :name=2>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="属性名" prop="ProductDetail_Properties" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_Properties"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="单位" prop="ProductDetail_Unit" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_CP"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售规格" prop="ProductDetail_sales_specification" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_sales_specification"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="典型值" prop="ProductDetail_typical_value" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_typical_value"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="测试方法" prop="ProductDetail_test_method" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_test_method"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性三" :name=3>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="适用密度范围" prop="ProductDetail_density_range" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_density_range"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="稳泡能力" prop="ProductDetail_stabilizing_porency" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_stabilizing_porency"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="泡孔结构" prop="ProductDetail_cell_structure" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_cell_structure"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="加工宽容度" prop="ProductDetail_processing_latitude" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_processing_latitude"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="低挥发" prop="ProductDetail_low_VOC" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_low_VOC"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="水解稳定性" prop="ProductDetail_sensitive_to_hydrolysis" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_sensitive_to_hydrolysis"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="阻燃性能" prop="ProductDetail_FR_property" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_FR_property"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性四" :name=4>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="炼油 Banner （异构）" prop="ProductDetail_refinery_banner" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_refinery_banner"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="炼油 Inovyn（异构）" prop="ProductDetail_refinery_inovyn" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_refinery_inovyn"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="炼油 AGC(I grade)（重整）" prop="ProductDetail_refinery_AGC" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_refinery_AGC"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清洗 AGC(S grade)" prop="ProductDetail_washing_AGC_S" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_washing_AGC_S"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清洗 AGC(M grade)" prop="ProductDetail_washing_AGC_M" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_washing_AGC_M"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="制冷 AGC(S grade)" prop="ProductDetail_washing_AGC_Cooling_S" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_washing_AGC_Cooling_S"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="closedDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api/api'
import cxf from '@/utils/GeneralFn'
import { Plus, Delete } from '@element-plus/icons-vue'
    export default {
        name: "addProductDialog",
        components: { 
            "pfPlus": Plus,
            "pfDelete": Delete,
            // "pfInfoFilled": InfoFilled
         },
        data() {
            return {
                iconArr:{
                    "pfPlus":Plus
                },
                mType:cxf.getMainType(),
                sType:[],
                productFile:[],
                lang:cxf.getProductLang(),
                status:cxf.getProductStatus(),
                dialogFormVisible:false,
                formLabelWidth:100,
                formTypeNumberLabelTypeWidth:200,
                formProduct: {
                    attchs: [],
                    isShow:0,
                    lang:'',
                    typeNumberName:1,
                },
                formProductRules:{
                    ProductDetail_mtype: [
                        { required: true, message: 'Please input main type', trigger: 'blur' },
                    ],
                    ProductDetail_stype: [
                        { required: true, message: 'Please input sub type', trigger: 'blur' },
                    ]
                },
                timeImageKey:0
            }
        },
        props:{
            isAddProductShow:Boolean,
            timekey:Number,
        },
        created(){
        },
        methods:{
            closedDialog(){
                this.dialogFormVisible = false;
                this.$refs['formProduct'].resetFields();
                this.$emit('isAddProductShow', false);
            },
            submitForm(){
                this.$refs['formProduct'].validate(( valid ) => {
                    if (valid) {
                        let _addFromData = new FormData();
                        const data = this.formProduct;
                        _addFromData.append("apiType", "fromData");
                        for (let item in data) {
                            if ( item === 'attchs') {
                                for (let d in this.productFile) {
                                    if (this.productFile.length !== 0 ) {
                                        _addFromData.append('file', this.productFile[d]);
                                    }
                                }
                            } else {
                                if ( data[item] ) {
                                    _addFromData.append(item, data[item]);
                                }
                            }
                            
                        }

                        api.postAddProduct( _addFromData ).then( res => {
                            if ( res.data.success) {
                                this.$message({
                                    message: '产品录入成功！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.dialogFormVisible = false;
                            this.$refs['formProduct'].resetFields();
                            this.$emit('hanldeCurrentPage');
                        }).catch( () => {
                            this.$message({
                                message: '产品录入出错，请联系相关员！',
                                type: 'errow'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            async handleAvatarSuccess( n ,file) {
                const _addFromData = new FormData();
                _addFromData.append("apiType", "fromData");
                _addFromData.append("file", file.raw)

                let _resImage = await api.postUploadImage( _addFromData );
                
                if ( _resImage.data.success ) {
                    let imageId = _resImage.data.data;
                    this.productFile.push(file.raw)
                    let _resimageUrl = await api.getSysFileInfoPreview( { id:imageId } );
                    if ( _resimageUrl.status ) {
                        this.formProduct.attchs.push(window.URL.createObjectURL(new Blob([_resimageUrl.data])));
                        console.log(this.formProduct.attchs);
                    }
                } else {
                    this.$message({
                        message: '图片录入出错，请联系相关员！',
                        type: 'errow'
                    })
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            handleRemoveImage ( n ) {
                this.formProduct.attchs = this.formProduct.attchs.filter( ( item, index ) => {
                    if (  item == n) {
                        this.productFile.splice(index, 1);
                    }
                    if ( item != n ) {
                        return item;
                    }
                });
            },
            handleSubType( mid ) {
                this.sType = cxf.getSubType( mid );
            },
            spanleft( index ) {
                if ( index === 0 ) {
                    return "left:0px;"
                } else {
                    let _wt = index * 100 + index * 20;
                    return "left:" + _wt + "px;"
                }
            }
        },
        watch:{
            isAddProductShow( newv ){
                this.dialogFormVisible = newv;
            },
            timekey( newv, oldv ){
                if (newv !== oldv && oldv !== "")
                this.dialogFormVisible = this.$props.isAddProductShow;
            },
            'formProduct.attchs': {
                handler(newVal, oldVal) {
                    console.log(newVal);
                    console.log(oldVal);
                },
                immediate: true
            }
        }
    }
</script>


<style scoped>
.avatar-uploader span,i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 15px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
.dialog-footer {
    padding-top:20px;
}
.el-tabs__content{
    height: 200px !important;
}
.removeImage{
    width: 100px;
    height: 30px;
    z-index: 2000 !important;
    position: absolute;
    top:0px;
    background: black;
    opacity: 0.5;
}
</style>